if (!customElements.get('newsletter-signup-form')) {
  customElements.define(
    'newsletter-signup-form',
    class NewsletterSignupForm extends HTMLElement {
      // BND-119: invia alla stessa azione AJAX (`submit_frontend_form`) che il
      // plugin EmailOctopus usa già sul sito. La risposta è {errors, message},
      // dove `message` è una chiave (message_success, message_invalid_email,
      // message_bot, ...) definita dal plugin — non c'entra con il consenso,
      // che qui è solo un controllo lato client (il plugin non lo riceve).
      static LIST_ID = 'bd51b9dc-bfda-11ec-9258-0241b9615763';

      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.endpoint = (this.dataset.endpoint || '').trim();

        this.form = this.querySelector(`#NewsletterSignupForm-${this.sectionId}`);
        this.emailInput = this.querySelector(`#NewsletterSignup-email-${this.sectionId}`);
        this.consentInput = this.querySelector(`#NewsletterSignup-consent-${this.sectionId}`);
        this.honeypotInput = this.querySelector(`#NewsletterSignup-hp-${this.sectionId}`);
        this.messageBox = this.querySelector('[data-newsletter-signup-message]');
        this.submitButton = this.form?.querySelector('button[type="submit"]');

        this.messages = {
          message_success: this.dataset.msgSuccess,
          consent_required: this.dataset.msgConsentRequired,
          message_missing_email: this.dataset.msgInvalidEmail,
          message_invalid_email: this.dataset.msgInvalidEmail,
          message_bot: this.dataset.msgError,
          error: this.dataset.msgError,
        };

        this.form?.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();

        if (!this.endpoint || this.submitButton?.disabled) return;

        // Consenso mancante: controllo solo nostro, il plugin non lo riceve.
        if (!this.consentInput || !this.consentInput.checked) {
          this.showMessage('consent_required');
          return;
        }

        // Honeypot: si finge un successo senza inviare nulla.
        if ((this.honeypotInput?.value || '').trim() !== '') {
          this.showMessage('message_success');
          return;
        }

        const email = (this.emailInput?.value || '').trim();

        this.setLoading(true);

        const body = new URLSearchParams({
          action: 'submit_frontend_form',
          'form_data[0][name]': 'EmailAddress',
          'form_data[0][value]': email,
          list_id: NewsletterSignupForm.LIST_ID,
        });

        fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          body: body.toString(),
        })
          .then((response) => response.json())
          .then((result) => {
            const key = (result && result.message) || 'error';

            if (!result || result.errors === false) {
              this.form.reset();
              this.showMessage('message_success');
            } else {
              this.showMessage(key);
            }
          })
          .catch(() => {
            this.showMessage('error');
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        if (this.submitButton) this.submitButton.disabled = isLoading;
        this.emailInput?.toggleAttribute('disabled', isLoading);
      }

      showMessage(key) {
        if (!this.messageBox) return;

        const isSuccess = key === 'message_success';
        const text = this.messages[key] || this.messages.error;

        this.messageBox.textContent = text;
        this.messageBox.hidden = false;
        this.messageBox.setAttribute('role', isSuccess ? 'status' : 'alert');
        this.messageBox.classList.toggle('alert', true);
        this.messageBox.classList.toggle('alert--success', isSuccess);
        this.messageBox.classList.toggle('alert--error', !isSuccess);

        if (key === 'message_invalid_email' || key === 'message_missing_email') {
          this.emailInput?.setAttribute('aria-invalid', 'true');
          this.emailInput?.focus();
        } else {
          this.emailInput?.removeAttribute('aria-invalid');
        }
      }
    }
  );
}
